import { render, staticRenderFns } from "./ContentBase.vue?vue&type=template&id=227c047a&"
import script from "./ContentBase.vue?vue&type=script&lang=ts&"
export * from "./ContentBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports